export const PROJECT_SETTINGS_SAVE = 'project-forms.settings-save';
export const PROJECT_CREATE_WO_PRODUCTS = 'project-forms.create-without-products';
export const PROJECT_DELETE = 'project-forms.project-delete';
export const PROJECT_COPY = 'project-forms.project-copy';
export const PROJECT_SETTINGS_FORM_LOAD = 'project-forms.settings-form-load';
export const PROJECT_SHARED_SAVE_CLICK = 'project-forms.save-a-shared-project';
export const PROJECT_SHARE_CLICK = 'project-forms.share-click';

export const DELETE_GROUP_OPERATION = 'DELETE_GROUP';
export const DELETE_ITEM_OPERATION = 'DELETE_ITEM';

export const PROJECT_ALREADY_EXISTS_ERROR_1 = 'Project name already exists';
export const PROJECT_ALREADY_EXISTS_ERROR_2 = 'A project with this name already exists.';
// eslint-disable-next-line max-len
export const PROJECT_ALREADY_EXISTS_MESSAGE = 'A project with this name already exists. Please choose a different name.';
export const PROJECT_CREATE_ACCOUNT_ERROR = 'We couldn\'t verify your account information. '
  + 'Please refresh the page and try again.';
export const GROUP_ALREADY_EXITS_ERROR = 'Group already exists';

// eslint-disable-next-line max-len
export const INVALID_PROJECT_TEXT_MESSAGE = 'Invalid Text: Only a-z, 0-9, ! @ # $ % ^ & * ( ) - _ + , . ? " \' : ; \\ are allowed.';
export const EMPTY_PROJECT_NAME_MESSAGE = 'Enter Project Name';
export const EMPTY_GROUP_NAME_MESSAGE = 'Enter Group Name';
export const EMPTY_SUBMITTED_GROUP_NAME_MESSAGE = 'Please enter a group name';
export const INVALID_NAME_LENGTH_MESSAGE = 'Project Names can be at most 80 characters';
export const INVALID_GROUP_LENGTH_MESSAGE = 'Group Names can be at most 50 characters';
export const INVALID_ADDRESS_LENGTH_MESSAGE = 'Address can be at most 60 characters';
export const INVALID_PROPERTY_TYPE_LENGTH_MESSAGE = 'Property type description can be at most 21 characters';
export const INVALID_JOB_SITE_LENGTH_MESSAGE = 'Job Site Conditions can be at most 45 characters';
export const INVALID_DELIVERY_INSTRUCTIONS_LENGTH_MESSAGE = 'Delivery Requirements can be at most 200 characters';
export const INVALID_PHONE_NUMBER_LENGTH_MESSAGE = 'Phone Number can be at most 10 characters';
export const INVALID_PHONE_NUMBER_FORMAT_MESSAGE = 'Phone Number must contain only numbers and be 10 digits long';
export const INVALID_DELIVERY_CONTACT_NAME_LENGTH_MESSAGE = 'Contact Name can be at most 40 characters';
export const INVALID_SECURITY_CODE_LENGTH_MESSAGE = 'Security Code can be at most 8 characters';
export const INVALID_LOCKBOX_CODE_LENGTH_MESSAGE = 'Lockbox Code can be at most 8 characters';
export const INVALID_LOCKBOX_LOCATION_LENGTH_MESSAGE = 'Lockbox Location can be at most 25 characters';
export const INVALID_JOB_SITE_HOURS_START_FORMAT_MESSAGE = 'Job Site Hours Start must be a valid time';
export const INVALID_JOB_SITE_HOURS_END_FORMAT_MESSAGE = 'Job Site Hours End must be a valid time';
export const INVALID_JOB_SITE_HOURS_WINDOW_MESSAGE = 'Job site hours must be a minimum of 6 hours.';
export const MISSING_JOB_SITE_HOURS_END_MESSAGE = 'Please select an end time.';
export const EMPTY_PROJECT_TYPE_MESSAGE = 'Please provide a Project Type';
export const EMPTY_PROPERTY_TYPE_MESSAGE = 'Please describe the Property Type';
export const INVALID_TYPE_LENGTH_MESSAGE = 'Project Types can be at most 40 characters';
export const INVALID_NOTE_LENGTH_MESSAGE = 'Project Description can be at most 1000 characters';
export const INVALID_START_DATE = 'Invalid start date';
export const INVALID_END_DATE = 'Invalid end date';
export const INVALID_ZIP_CODE = 'Please provide a valid ZIP code';
export const EMPTY_ZIP_CODE_MESSAGE = 'Zip code is required if address is provided.';
export const EMPTY_ADDRESS_MESSAGE = 'Address Line 1 is required if an address is provided.';

export const PROJECT_NAME_KEY = 'projectName';
export const PROJECT_TYPE_KEY = 'projectType';
export const PROJECT_DESCRIPTION_KEY = 'projectDescription';
export const JOB_SITE_CONDITIONS_KEY = 'siteConditions';
export const DELIVERY_INSTRUCTIONS_KEY = 'deliveryInstructions';
export const DELIVERY_CONTACT_NAME_KEY = 'name';
export const DELIVERY_CONTACT_PHONE_KEY = 'phone';
export const ADDRESS_KEY = 'address';
export const SECURITY_CODE = 'securityCode';
export const LOCKBOX_CODE = 'lockboxCode';
export const LOCKBOX_LOCATION = 'lockboxLocation';
export const JOB_SITE_HOURS_START = 'jobSiteHoursStart';
export const JOB_SITE_HOURS_END = 'jobSiteHoursEnd';
export const PROPERTY_TYPE_KEY = 'propertyType';
export const PROPERTY_TYPE_OTHER_KEY = 'propertyTypeOther';
export const PACKAGE_PLACEMENT_KEY = 'preferredPackagePlacement';
export const DELIVERY_TYPE_KEY = 'deliveryType';
export const HAS_STAIRS_KEY = 'hasStairs';
export const GROUP_NAME_KEY = 'groupName';
export const ESTIMATED_START_DATE_KEY = 'estimatedStartDate';
export const ESTIMATED_END_DATE_KEY = 'estimatedEndDate';
export const ADDRESS_LINE_1_KEY = 'addressLine1';
export const ADDRESS_LINE_2_KEY = 'addressLine2';

// The required Delivery Zip Code at the top of the create drawer. [DSCVR-5168 AC1]
export const DELIVERY_ZIP_HELPER_TEXT = 'Providing a zip code ensures accurate pricing and availability';
export const DELIVERY_ZIP_REQUIRED_MESSAGE = 'Delivery zip code is required';

// The optional section below the two required fields. It was "Project Details (Optional)" with
// generic inventory/delivery sub-copy, which is what kept the jobsite address undiscoverable -
// the address was bundled with unrelated benefits behind a label that never named it. [DSCVR-5168]
export const PROJECT_DELIVERY_DETAILS_TITLE_BASE = 'Project Delivery Details';
export const PROJECT_DELIVERY_DETAILS_TITLE = 'Project Delivery Details (Optional)';
// eslint-disable-next-line max-len
export const PROJECT_DELIVERY_DETAILS_HELPER_TEXT = 'Add your project address and delivery details now and it will automatically apply it to all orders linked to this project. so you won\'t need to re-enter it each time you check out.';

// Project Setup's copy, unchanged. The switched-on create drawer's Delivery Contact section uses its
// own wording below. [DSCVR-5191]
export const ADDRESS_FORM_DELIVERY_CONTACT_HELPER_TEXT = 'This is the person drivers will call for delivery options';
export const JOBSITE_DELIVERY_CONTACT_HELPER_TEXT = 'This is the person drivers will call for delivery orders';
// eslint-disable-next-line max-len
export const ADDRESS_FORM_ADDRESS_DETAILS_HELPER_TEXT = 'This information will be saved to streamline all project order information in cart and checkout';
// eslint-disable-next-line max-len
export const ADDRESS_FORM_DELIVERY_TIME_WINDOW_HELPER_TEXT = 'This information will be saved to ensure all deliveries arrive to the your delivery location during working hours';
// eslint-disable-next-line max-len
export const ADDRESS_FORM_DELIVERY_INSTRUCTIONS_HELPER_TEXT = 'This information will be shared with the delivery driver when possible to ensure deliveries meet your expectations';

export const ACTIVE = 'active';
export const ARCHIVED = 'archived';
export const ARCHIVE = 'Archive';
export const SET_ACTIVE = 'Set Active';
export const DELETE = 'Delete';
export const STATUS_SESSION_STORAGE_KEY = 'status';

export const MODAL_INFO_ARRAY = [{
  type: 'Delete',
  header: 'Delete Project?',
  query: 'Are you sure you want to delete this project?',
  warning: 'Deleteing the project will permanently remove it and its contents. This action cannot be undone.',
  button: 'Delete'
},
{
  type: 'Archive',
  header: 'Archive Project?',
  query: 'Are you sure you want to archive',
  warning: `Archiving the project will keep it accessible for future reference, but it will no longer be
    actively used or populated. You can reactivate it later if needed.`,
  button: 'Archive'
},
{
  type: 'Reactivate',
  header: 'Set Project as Active?',
  query: 'Are you sure you want to set this project as active?',
  warning: `Setting the project as active will allow users to make edits and perform all actions associated
    with an active project.`,
  button: 'Active'
}];

// generals
export const STR_1 = '1';
export const STR_2 = '2';
export const CANCEL_BUTTON = 'cancel button';
export const X_BUTTON = 'x button';
export const BACK_BUTTON = 'back button';
export const REPLY_SENT = 'reply sent';

// Analytics
export const PROJECT_CREATE_BUTTON_CLICKED = 'projects: create new project button';
export const PROJECT_CREATE_OVERLAY = 'projects: create new project overlay';
export const PROJECT_CREATE_CLICK = 'projects: create new project overlay: create project button';
export const PROJECT_CREATE_SUCCESS = 'new project created';
export const PROJECT_STATUS_MENU_CLICK = 'projects: status menu click';
export const PROJECT_STATUS_OVERLAY = 'projects: status overlay';
export const PROJECT_STATUS_CHANGE = 'projects: status change';
export const PROJECTS_INTERACTION = 'projects.interaction';
export const PROJECT_DETAILS_SHARE_YOUR_PROJECT = 'projects: project details: share your project';
export const SHARE_YOUR_PROJECT_SEND = 'projects: project details: share your project: send button';
export const SHARE_YOUR_PROJECT_STEP = 'projects: project details: share your project: step';
export const PROJECT_REPLY_TO_MSG_OVERLAY = 'projects: reply to message overlay';
export const SHARE_YOUR_PROJECT_CONTINUE = 'projects: project details: share your project: continue';
export const PROJECT_DETAILS_REPLY_TO_MESSAGE_OVERLAY = 'projects: project details: reply to message overlay';
export const PROJECT_NEW_MESSAGE_CLICK = 'projects: project details: new message click';
export const PROJECT_REPLY_BTN_CLICK = 'projects: project details: reply button';
export const GROUP_NAME_AND_NEED_BY_EDITED = 'group name and need by edited';
export const GROUP_NAME_EDITED = 'group name edited';
export const GROUP_NEED_BY_EDITED = 'need by edited';
export const EDIT_GROUP_OVERLAY = 'project-details.edit-group-accordion';
export const PAST_NEED_BY_DATE_ERROR = 'This date is in the past. Select a future date.';
export const GROUP_SCHEDULE_EDITED = 'group schedule edited';
export const GROUP_DETAILS_TAB = 'GROUP_DETAILS';
export const GROUP_ITEMS_TAB = 'GROUP_ITEMS';
export const SCHEDULED_DELIVERY_BUTTON_CLICK = 'scheduled delivery button click';
export const SCHEDULED_DELIVERY_OVERLAY = 'scheduled delivery overlay';

// Project Comments
export const PROJECT_COMMENTS_EMPTY_TITLE = 'No Comments yet.';
export const PROJECT_COMMENTS_EMPTY_SUBTITLE = 'Leave a note for your team to keep everyone on the same page.';
export const PROJECT_COMMENTS_PAGE_SIZE = 20;
export const NOTE_STATUS_UNRESOLVED = 'UNRESOLVED';
export const NOTE_STATUS_RESOLVED = 'RESOLVED';

// Line Item Notes
export const LINE_ITEM_NOTES_EMPTY_TITLE = 'No notes yet.';
// eslint-disable-next-line max-len
export const LINE_ITEM_NOTES_EMPTY_SUBTITLE = 'Add a note to track details, substitutions, or anything worth remembering for this material.';
export const LINE_ITEM_NOTES_PAGE_SIZE = 20;
